
import Header from './general/Header';
import Footer from './general/Footer';
import Notice from './general/Notice';

import ArticleViewer from './articles/ArticleViewer';



import './App.css'

function App() {

  return (
    <>
    <Header />
<Notice />
            <ArticleViewer />
<Footer/>
</>
  )
}

export default App
